//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { memo } from "react";
import { FileIcon, X, Eye } from "lucide-react";
import { AttachedFile } from '../EmailComposer/types';
import { formatFileSize } from './helpers';

const AttachmentCard = memo<{
  file: AttachedFile;
  onRemove: (id: string) => void;
  onPreview: (file: AttachedFile) => void;
}>(({ file, onRemove, onPreview }) => (
  <div
    className={tw`flex items-center gap-2 bg-white border rounded-lg px-3 py-2 shadow-sm transition-shadow ${
      file.uploading
        ? "border-blue-300 bg-blue-50"
        : file.uploadError
        ? "border-red-300 bg-red-50"
        : "border-gray-300"
    }`}
  >
    <FileIcon
      size={18}
      className={tw`${file.uploadError ? "text-red-600" : "text-gray-600"}`}
    />
    <div className={tw`flex flex-col`}>
      <span
        className={tw`text-sm font-medium max-w-[200px] truncate ${
          file.uploadError ? "text-red-800" : "text-gray-800"
        }`}
        title={file.file.name}
      >
        {file.file.name}
      </span>
      <span
        className={tw`text-xs ${
          file.uploadError ? "text-red-500" : "text-gray-500"
        }`}
      >
        {file.uploading
          ? "Uploading..."
          : file.uploadError || formatFileSize(file.file.size)}
      </span>
    </div>

    <button
      type="button"
      onClick={() => onPreview(file)}
      className={tw`ml-2 hover:bg-gray-100 rounded-full p-1 transition-colors`}
    >
      <Eye size={16} className={tw`text-gray-600`} />
    </button>

    <button
      type="button"
      onClick={() => onRemove(file.id)}
      className={tw`ml-2 hover:bg-gray-100 rounded-full p-1 transition-colors ${
        file.uploading ? "opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={file.uploading}
    >
      <X size={16} className={tw`text-gray-600`} />
    </button>
  </div>
));

AttachmentCard.displayName = "AttachmentCard";

export { AttachmentCard };